
import { Component, Vue } from 'vue-property-decorator';

// Components
import VButton from '@/components/VButton/VButton.vue';

@Component({
    components: { VButton },
})
export default class VAcceptList extends Vue {}
